/**
 * PageHeader
 *
 * Tüm sayfalardaki standart beyaz header kartı.
 *
 * Props:
 *   icon        – emoji  (ör: "🏢")
 *   iconColor   – Tailwind gradient  (ör: "from-blue-600 to-indigo-700")
 *   iconShadow  – Tailwind shadow rengi  (ör: "shadow-blue-200")  default: "shadow-indigo-200"
 *   title       – Ana başlık (uppercase yapılır)
 *   subtitle    – Alt başlık
 *   children    – Sağ tarafa yerleşen aksiyon alanı (buton, vs.)
 *
 * Kullanım:
 *   <PageHeader
 *     icon="🏢"
 *     iconColor="from-blue-600 to-indigo-700"
 *     iconShadow="shadow-blue-200"
 *     title="Anlaşmalı Firmalar"
 *     subtitle="Kurumsal fiyat anlaşmaları ve kural yönetimi"
 *   >
 *     <button onClick={...}>+ YENİ FİRMA EKLE</button>
 *   </PageHeader>
 */

export default function PageHeader({
  icon,
  iconColor = 'from-blue-600 to-indigo-700',
  iconShadow = 'shadow-indigo-200',
  title,
  subtitle,
  children,
}) {
  return (
    <div className="relative overflow-hidden bg-white rounded-[2.5rem] border border-gray-200 shadow-sm p-6 md:p-8">
      {/* Dekoratif arka plan blur'lar */}
      <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-blue-50 rounded-full blur-3xl opacity-60 pointer-events-none transform-gpu" />
      <div className="absolute bottom-0 left-0 -ml-16 -mb-16 w-80 h-80 bg-indigo-50 rounded-full blur-[80px] opacity-40 pointer-events-none transform-gpu" />

      <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8 leading-none text-left">
        {/* Sol: ikon + başlık */}
        <div className="flex items-center gap-6 min-w-0">
          <div className={`w-16 h-16 bg-gradient-to-br ${iconColor} rounded-2xl flex-shrink-0 flex items-center justify-center text-white text-3xl shadow-2xl ${iconShadow}`}>
            {icon}
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tighter uppercase leading-none truncate">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm font-bold text-gray-400 mt-2 uppercase tracking-widest truncate leading-none">
                {subtitle}
              </p>
            )}
          </div>
        </div>

        {/* Sağ: aksiyon alanı */}
        {children && (
          <div className="flex items-center gap-3 flex-shrink-0">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
